import * as actions from './actions'
import { ActionType, createReducer } from 'typesafe-actions'
export interface InteractionCapabilities {
  touch: boolean
  hover: boolean
}

export const reducer = createReducer<
  InteractionCapabilities,
  ActionType<typeof actions>
>({
  touch: false,
  hover: false
})
  .handleAction(actions.setHovercapability, (state, { payload }) => ({
    ...state,
    hover: payload
  }))
  .handleAction(actions.setTouchCapability, (state, { payload }) => ({
    ...state,
    touch: payload
  }))
